import React, { useEffect, useRef, useState } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { CustomAdvancedMenuList, CustomDialog } from '../../../components/StyledComponents';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ControlpanelErrorButton, ControlpanelPrimaryButton, ControlpanelSecondaryButton, ControlpanelSuccessButton, GrayIconButton } from '../../../components/StyledButton';
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from '../../../components/CustomInput';
import { useConnectWS, useGetDeviceDetails, useReadCard } from '../../../hooks/useCheckid';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CustomSelect from '../../../components/CustomSelect';
import { useGetGeneralPolicyCountry } from '../../../hooks/useGeneralService';
import { initialSelectedPhoneCountry } from '../../../assets/data/common';
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import CustomDatePicker from '../../../components/CustomDatePicker';
import { useAuth } from '../../../context/AuthContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { format } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import Webcam from "react-webcam";
import { getEventsVisitorsById, getRegistrationsList } from '../../../axios/Visitor/VisitorApi';
import avatar_2 from "../../../assets/images/logo/avatar-default-logo.png";
const DetailVisitorDialog = ({ id, data, onClose, refreshData, handleRefreshData, refresh }) => {
    const [show, hide] = useLoading();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [readingCard, setReadingCard] = useState(false);
    const [isMissingSoftware, setIsMissingSoftware] = useState(false);
    const getDevice = useGetDeviceDetails();
    const connectWS = useConnectWS();
    const readCard = useReadCard();
    const language = useSelector((state) => state.languageR.language);
    const [isReadCard, setIsReadCard] = useState(false);
    const [dataReadcard, setDataReadcard] = useState(null);
    const skipBlurRef = useRef(false);
    const [onBlurEvent, setonBlurEvent] = useState(false);
    const { data: countries } = useGetGeneralPolicyCountry();
    const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
        initialSelectedPhoneCountry
    );
    const { genaralSettingDateFormat } = useAuth();
    const [openAdvanced, setOpenAdvanced] = useState(false);

    const [openCamera, setOpenCamera] = useState(false);
    const webcamRef = useRef(null);

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();

        setFormData((prev) => ({
            ...prev,
            faceImage: imageSrc,
        }));

        setOpenCamera(false);
    };

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const initialFormData = {
        fullName: '',
        personalID: '',
        email: '',
        phone: '',
        joinDate: '',
        faceImage: '',
        langId: localStorage.getItem("i18nextLngId")
    };

    const [formData, setFormData] = useState(initialFormData);

    const [validationMessages, setValidationMessages] = useState({
        fullName: "",
        personalID: "",
        email: "",
        phone: "",
        joinDate: "",
    });

    const handleDataChange = (name, newData) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newData,
        }));
    };

    useEffect(() => {
        const fetchDetail = async () => {
            if (!id) return;

            try {
                show();
                setIsLoading(true);

                const payload = {
                    eventVisitorId: id,
                    langId: localStorage.getItem("i18nextLngId"),
                };

                const res = await getEventsVisitorsById(payload);

                if (res?.data?.responseCode === 0) {

                    const found = res?.data?.data?.[0];

                    setFormData({
                        fullName: found?.fullName || "",
                        personalID: found?.citizenNumber || "",
                        email: found?.email || "",
                        phone: (found?.mobile || "").trim(),
                        joinDate: found?.joinDate
                            ? format(new Date(found.joinDate), genaralSettingDateFormat)
                            : "",
                        faceImage: found?.profileImageBase64 || "",
                        status: found?.status || "",
                        langId: localStorage.getItem("i18nextLngId"),
                    });

                } else {
                    toast.error(
                        res?.data?.message ||
                        t("common.something-went-wrong")
                    );
                }

            } catch (error) {

                console.error(error);

                toast.error(
                    error?.response?.data?.message ||
                    t("common.something-went-wrong")
                );

            } finally {
                hide();
                setIsLoading(false);
            }
        };

        fetchDetail();
    }, [id, show, hide]);

    const handleCloseDialog = () => {
        if (isLoading) return;
        setFormData(initialFormData);
        onClose();
    };

    const updateFormDataAndValidate = (name, value) => {
        if (name === 'departmentPrefix') {
            // Giới hạn 2 ký tự + uppercase
            const trimmedValue = value.toUpperCase().slice(0, 2);

            setFormData((prevData) => ({
                ...prevData,
                [name]: trimmedValue,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        updateFormDataAndValidate(name, value);

        if (name === "phone") {
            const phone = value.trim();

            if (!phone) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            } else if (!/^\d{9,13}$/.test(phone)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "common.content-024", // bạn tự define i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            }
        }

        if (name === "email") {
            const email = value.trim();

            if (!email) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "validation.email-invalid-format", // key i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            }
        }
    };

    const handleSubmit = async () => {
        if (
            !formData.fullName ||
            !formData.personalID ||
            !formData.joinDate ||
            !formData.email ||
            !formData.phone
        ) {
            toast.error(t("common.fill-required"));
            return;
        }

        // 👉 remove prefix base64
        const cleanBase64 = formData.faceImage
            ? formData.faceImage.replace(/^data:image\/\w+;base64,/, "")
            : "";

        const payload = {
            ...formData,
            faceImage: cleanBase64,
            phone: `${selectedPhoneCountry.callingCode}${formData.phone}`,
        };

        toast.success(t("common.add-success"));

        setFormData(initialFormData);
        onClose();
        handleRefreshData?.();
    };
    const fileInputRef = useRef(null);

    const formatBase64Image = (base64) => {
        if (!base64) return "";

        if (base64.startsWith("data:image")) return base64;

        // detect loại ảnh (optional nâng cao)
        const isPng = base64.startsWith("iVBOR"); // PNG signature
        const type = isPng ? "image/png" : "image/jpeg";

        return `data:${type};base64,${base64}`;
    };

    const handleReject = async () => {
        try {
            show();
            setIsLoading(true);
            toast.success(t("common.reject-success"));
            onClose();
        } finally {
            hide();
            setIsLoading(false);
        }
    }

    const handleApprove = async () => {
        try {
            show();
            setIsLoading(true);
            toast.success(t("common.approve-success"));
            onClose();
        } finally {
            hide();
            setIsLoading(false);
        }
    }

    return (
        <>
            <CustomDialog maxWidth={'md'} open loading={isLoading} onClose={handleCloseDialog} keepMounted>
                <DialogTitle>
                    <div className='flex justify-between'>
                        <div className='flex items-center gap-4'>
                            <p className='text-xl font-semibold '>{t('common.user-detail')}</p>
                        </div>
                        <GrayIconButton onClick={handleCloseDialog} disabled={isLoading}>
                            <CloseIcon />
                        </GrayIconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className='space-y-4 mt-4'>
                        <div className="flex items-start justify-center gap-3">
                            <div className="flex items-center justify-center overflow-hidden border border-gray-200 p-[5px] rounded-[4px]">
                                {formData.faceImage ? (
                                    <img
                                        src={
                                            formData.faceImage
                                        }
                                        alt="preview"
                                        className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                    />
                                ) : (
                                    <img
                                        src={avatar_2}
                                        alt="preview"
                                        className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                    />
                                )}
                            </div>
                        </div>

                        <div>
                            <label>{t('common.name')} <span className="text-red-500">*</span></label>
                            <CustomInput name='fullName' value={formData.fullName} handleInputChange={handleInputChange} disabled readOnly={true} />
                        </div>

                        <div>
                            <label>{t('common.personal-id')}<span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center">
                                <input
                                    type="number"
                                    name="personalID"
                                    className={`form-control h-[40px] no-spin-buttons relative z-40 pr-12 ${!!validationMessages.personalID ? "invalid" : ""
                                        }`}
                                    value={formData.personalID}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // ✅ Chỉ cho phép tối đa 12 chữ số
                                        if (value.length <= 12) {
                                            handleInputChange(e);
                                            setFormData((prev) => ({ ...prev, fullName: "" }));
                                        }
                                    }}
                                    disabled
                                />
                            </div>
                        </div>

                        <div>
                            <label>{t('common.email')} <span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center h-10">
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control h-10 pr-10"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    disabled
                                />
                            </div>

                            {/* MESSAGE */}
                            {validationMessages.email && (
                                <p className="mt-2 text-sm text-red-500">
                                    {t(validationMessages.email)}
                                </p>
                            )}
                        </div>

                        <div className="space-y-2 col-span-2">
                            <label className="block">{t("common.phone")} <span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center h-10">
                                <input
                                    type="text"
                                    name="phone"
                                    className="form-control h-10 pr-10"
                                    value={formData.phone}
                                    disabled
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className="border-t border-[#E5E7EB] pt-2 mt-4">
                            <label>{t('common.select-date')}</label> <span className='text-[#EF4444] ml-1'>*</span>
                            <CustomInput
                                name="joinDate"
                                value={formData.joinDate}
                                className=""
                                dataType="joinDate"
                                disabled
                                readOnly={true}
                            />
                        </div>
                    </div>
                </DialogContent>
            </CustomDialog>
        </>
    )
}

export default DetailVisitorDialog